import { JoynV2Api } from '../api/joyn/JoynApi';
import { normalizeBlacklistResponse } from './normalizeBlacklistResponse';

class BlacklistRepository {
  getBlacklistEntries = (email) =>
    JoynV2Api.get('/sammy/blacklist', { email }).then(
      normalizeBlacklistResponse,
    );

  removeFromBlacklist = (email) =>
    JoynV2Api.post('/sammy/blacklist/remove', { email });
}

export default new BlacklistRepository();
